var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('div',{staticClass:"empty-icon"},[_c('i',{class:_vm.icon})]),_c('div',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.title))]),(_vm.hint)?_c('div',{staticClass:"empty-hint"},[_vm._v(_vm._s(_vm.hint))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }